import { render, staticRenderFns } from "./TrigFunctionViz.vue?vue&type=template&id=1b892330&scoped=true"
import script from "./TrigFunctionViz.vue?vue&type=script&lang=js"
export * from "./TrigFunctionViz.vue?vue&type=script&lang=js"
import style0 from "./TrigFunctionViz.vue?vue&type=style&index=0&id=1b892330&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b892330",
  null
  
)

export default component.exports